import Ajv from "ajv";
import { policyDocumentsResponseSchema } from "../../../schemas/tpa/PolicyDocumentsResponse";

const ajv = new Ajv();

export const validateDocumentsResponse = ajv.compile(policyDocumentsResponseSchema);
